module.exports = __webpack_public_path__ + "img/menu_wave.a7d46a39.svg";